import React from 'react';
import { useParams } from 'react-router-dom';
import TeamSubteamMembersNavbar from 'team/components/subteams/members/TeamSubteamMembersNavbar';
import TeamSubteamMembersDashboard from './TeamSubteamMembersDashboard';

const TeamSubteamMembersContainer = ({ user, team }) => {
    const { subteamId } = useParams();

    return (
        <div>
            <TeamSubteamMembersNavbar subteamId={subteamId} />
            <TeamSubteamMembersDashboard
                user={user}
                team={team}
                subteamId={subteamId}
            />
        </div>
    );
};

export default TeamSubteamMembersContainer;

